import PendoMultiselect from '../multiselect/pendo-multiselect.vue.js';
import PendoMultiselectInput from '../multiselect/pendo-multiselect-input.vue.js';
import PendoCheckboxOption from '../multiselect/option-types/pendo-checkbox-option.vue.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoButton from '../button/pendo-button.vue.js';

var script = {
  components: {
    PendoButton,
    PendoCheckboxOption,
    PendoIcon,
    PendoMultiselect,
    PendoMultiselectInput
  },
  inject: ['$table'],
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  computed: {
    availableFilters() {
      return this.column.filters;
    },
    selectedFilters() {
      return this.availableFilters.filter(option => option.checked === true);
    },
    isColumnFiltered() {
      return this.selectedFilters.length;
    }
  },
  methods: {
    onFilterPanelOpen() {
      this.$table.showFilterPanel(this.column);
    },
    onFilterPanelClose() {
      this.$table.hideFilterPanel();
    },
    onClearFiltersClick() {
      this.$table.filterColumn({
        column: this.column,
        appliedFilters: []
      });
    },
    onFilterChange(value) {
      const model = Array.isArray(value) ? value : [value];
      const appliedFilters = model.filter(Boolean).map(filter => filter.value);
      this.$table.filterColumn({
        column: this.column,
        appliedFilters
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=filter-panel.vue2.js.map
